export default [
  {
    path: "/organigrama",
    name: "organigrama",
    component: () =>
      import(
        /* webpackChunkName: "organigrama" */ "./organigramaInstitucional.vue"
      ),
  },
];
